export default function useSendToGTM() {
  return (data = {}) => {
    if (typeof window === 'undefined') return false;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    return false;
  };
}
